import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import apiServices from "../../../services/api.services";

function generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
}

export const fetchCategory = createAsyncThunk('shops/fetchCategory', async ({title, shop_id}, {rejectWithValue}) => {
    const response = await apiServices.suggestCategory(title, shop_id);
    console.log(response)
    if (response.status !== 200) return rejectWithValue(response?.message || 'Something went wrong');
    return response.data;
})
export const fetchAttributes = createAsyncThunk('shops/fetchAttributes', async ({category_id, shop_id}, {rejectWithValue}) => {
    const response = await apiServices.getAttributes(category_id, shop_id);
    if (response.status !== 200) return rejectWithValue(response?.message || 'Something went wrong');
    return response.data;
})

const initProduct = {
    title: "",
    shop: -1,
    description: "",
    category_id: "",
    quantity: 0,
    price: {
        currency: "USD",
        amount: "",
    },
    package_weight: {
        value: "",
        unit: "POUND"
    },
    package_dimensions: {
        length: "",
        width: "",
        height: "",
        unit: "INCH",
    },
    brand_id: "7374732359353157382",//No brand
    main_images: [],
    attributes: [],
    skus: [],
    isLoading: false,
    error: "",
    category_data: []
}

export const productSlice = createSlice({
    name: 'product',
    initialState: initProduct,
    reducers: {
        updateProduct: (state, action) => {
            const {key, value} = action.payload;
            if (state.hasOwnProperty(key)) {
                state[key] = value;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategory.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchCategory.fulfilled, (state, action) => {
                state.isLoading = false
                state.category_id = action.payload.leaf_category_id
                let cateData = [];
                action.payload.categories.map((category) => {
                    cateData.push(category.name)
                })
                state.category_data = cateData
                state.error = null
            })
            .addCase(fetchCategory.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
            .addCase(fetchAttributes.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchAttributes.fulfilled, (state, action) => {
                state.isLoading = false
                state.attributes = action.payload.attributes
                state.error = null
            })
            .addCase(fetchAttributes.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
    },
})

export const {updateProduct} = productSlice.actions

export default productSlice.reducer